// Keep parity with r1-branding.scss
export class R1BrandingConstants {
    static black = '#101212'; // UI color (Doesn't match branding 2018-12-19)
    static white = '#ffffff';
    static gray = '#54585a'; // Branding color (as of 2018-12-19)
    static warmGray = '#5b514e'; // Branding color (as of 2018-12-19)
    static smoke = '#9da2a6'; // Branding color (as of 2018-12-19)
    static lightGray = '#ebebeb'; // UI color (Doesn't match branding 2018-12-19)
    static faintGray = '#efefef'; // Branding color (as of 2018-12-19)
    static darkBlue = '#01426a'; // UI color (Doesn't match branding 2018-12-19)
    static brilliantBlue = '#1174b6'; // UI color (Doesn't match branding 2018-12-19)
    static lightBlue = '#8db9ca'; // UI color (Doesn't match branding 2018-12-19)
    static orange = '#e87722'; // UI color (Doesn't match branding 2018-12-19)
    static orange2018 = '#ff9933'; // Branding color (as of 2018-12-19)
    static red = '#ef3742'; // Branding color (as of 2018-12-19)
    static green = '#64a70b'; // UI color (Doesn't match branding 2018-12-19)
    static lime = '#93d500'; // Branding color (as of 2018-12-19)
    static purple = '#7D4C79'; // Legacy branding color (Long live purple.)

    static overlay = 'rgba(58, 39, 39, 0.5)';

    static fontFamily = '"Open Sans", Arial, Helvetica, sans-serif"';

    static font10 = '10px';
    static font12 = '12px';
    static font14 = '14px';
    static font16 = '16px';
    static font18 = '18px';
    static font20 = '20px';
    static font24 = '24px';
}
